import { render, staticRenderFns } from "./blacklist-customer.vue?vue&type=template&id=6c918d66&"
import script from "./blacklist-customer.vue?vue&type=script&lang=js&"
export * from "./blacklist-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports